module.exports = __webpack_public_path__ + "img/image7.37cfedac.jpg";